import { iSupportedLanguages } from '~/App';

export const getLocale = (): iSupportedLanguages['language'] => {
  const locale = localStorage.getItem('i18nextLng') ?? 'pt-BR';

  return locale as iSupportedLanguages['language'];
};
